const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
  <g fill="none" fill-rule="evenodd">
    <path d="M0 0h56v56H0z" />
    <path
      d="M11.659 43.835c.285.285.621.478 1.008.578.386.1.777.1 1.172 0a2.18 2.18 0 001.02-.578l12.904-12.908 12.929 12.908a2.263 2.263 0 002.167.579c.386-.101.722-.294 1.008-.58.303-.285.5-.624.592-1.018a2.503 2.503 0 000-1.17 2.002 2.002 0 00-.592-1.007L30.964 27.732 43.867 14.85c.303-.286.5-.621.592-1.007a2.503 2.503 0 000-1.17 2.003 2.003 0 00-.592-1.019 2.182 2.182 0 00-1.008-.579c-.386-.1-.773-.1-1.16 0-.386.101-.722.294-1.007.58l-12.93 12.907L14.86 11.654a2.18 2.18 0 00-1.02-.579c-.395-.1-.786-.1-1.172 0-.387.101-.723.294-1.008.58-.303.284-.5.624-.593 1.018-.092.394-.088.784.013 1.17.1.386.294.721.58 1.007l12.928 12.882L11.66 40.639c-.286.285-.48.62-.58 1.007-.1.385-.105.775-.013 1.17.093.394.29.733.593 1.019z"
      fill="currentColor" fill-rule="nonzero" />
  </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=close.es-BYmVEyOJ.js.map
